import FullPageLoader from '@src/common/FullPageLoader';
import { useState } from 'react';
import DocumentTypeTab from '@src/component/insurance/common/DocumentTypeTab';
import DocumentTypeTabId from '@src/component/insurance/common/DocumentTypeTabId';
import {COUNTRY_CODE} from '@src/config/constant';
import { useLanguage } from '@src/context/LanguageContext';

const DocumentUpload = (props: { formType?: string }) => {
    let [loading, setLoading] = useState<boolean>(false)
    const {translations} = useLanguage();

    const setLoader = (loader: boolean) => {
        setLoading(loader)
    }

    return (
        <>
            <FullPageLoader show={loading} />
            <div className="document-upload-tabs" >
                <div className="doument-upload-left-panel">
                    <div className="heading-txt">
                        <h2>{translations.Insurance?.['Upload Documents'] || translations.commonMsg?.loading}</h2>
                    </div>
                    {
                       (COUNTRY_CODE==='id')?
                       <DocumentTypeTabId callFrom='docUpload' setLoader={setLoader} formType={props.formType} />
                       :<DocumentTypeTab callFrom='docUpload' setLoader={setLoader} />
                    }
                </div >
            </div >
        </>

    )

}
export default DocumentUpload;